import { render } from "./ClientInfoEdge.vue?vue&type=template&id=43744d40&ts=true"
import script from "./ClientInfoEdge.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientInfoEdge.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/edges/ClientInfoEdge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43744d40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43744d40', __exports__)) {
    api.reload('43744d40', __exports__)
  }
  
  module.hot.accept("./ClientInfoEdge.vue?vue&type=template&id=43744d40&ts=true", () => {
    api.rerender('43744d40', render)
  })

}


export default __exports__